import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useFieldValue } from "formik";
import * as Yup from "yup";
import { ControlState } from "../models/flexible/control-state";
import { combinePaths } from "../models/flexible/utils";
import { CoverageRequestTherapyDecision, Maybe } from "../models/generated/graphql";
import { getPathPrefix } from "../utils/get-path-prefix";
import { GeneralFieldController } from "./general-field-controller";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { useTranslation } from "react-i18next";
import { renderRequiredMessage } from "../utils/render-required-message";

export class CoverageStartDateFieldController extends GeneralFieldController {
	override useControlState(path: string): ControlState {
		const [decisionTherapy] = useFieldValue(combinePaths(getPathPrefix(path, 1), AttributeIdentifiers.DecisionTherapy));

		if (this.parent.context.noPatients && this.parent.context.noPatients > 0) {
			return "disabled";
		}
		return decisionTherapy === CoverageRequestTherapyDecision.Approved ? "enabled" : "hidden";
	}

	override useControlProps(path: string): Maybe<FlexControlProps> | undefined {
		const { t } = useTranslation();

		if (this.parent.context.noPatients && this.parent.context.noPatients > 0) {
			return {
				isTranslated: true,
				emptyValuePlaceholder: t("bulk-coverage-patient-placeholder"),
			};
		}

		return null;
	}

	override createValidationRule(_initialValues: unknown, translate: (key: string) => string): Yup.AnySchema {
		if (this.parent.context.noPatients && this.parent.context.noPatients > 0) {
			return super.createFieldValidationRuleByDataType(translate).optional();
		}

		return super.createFieldValidationRuleByDataType(translate).when(AttributeIdentifiers.DecisionTherapy, {
			is: CoverageRequestTherapyDecision.Approved,
			then: Yup.date()
				.nullable()
				.required(renderRequiredMessage(this.schema.attribute.identifier, translate))
		});
	}
}
